import { HoverableLinkSizes, styleConstants } from '@paywithextend/components'
import React from 'react'
import AccountVerificationTimedOut from 'src/assets/images/AccountVerificationTimedOut.svg'
import AppName from 'src/components/AppName/AppName'
import Box from 'src/components/Box/Box'
import ResourceCenterLink from 'src/components/ResourceCenterLink/ResourceCenterLink'
import { useTranslate } from 'src/localization/Trns'
import styled, { css } from 'styled-components'

const ListItem = styled.li`
  margin-top: 20px;
  margin: 0;
  padding: 15px 0 0 30px;
  text-indent: -30px;
  list-style-type: none;
  counter-increment: item;

  ::before {
    display: inline-block;
    width: 1em;
    padding-right: 15px;
    font-weight: bold;
    text-align: right;
    content: counter(item) '.';
  }
`

const AccountVerificationTimedOutBox = (): React.ReactElement => {
  const translate = useTranslate()

  return (
    <Box
      css={css`
        align-items: center;
        align-self: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 500px;
      `}
    >
      <img
        src={AccountVerificationTimedOut}
        alt={''}
        css={css`
          max-width: 106px;
        `}
      />
      <div
        css={css`
          display: flex;
          align-items: center;
          margin-top: 10px;
          color: ${styleConstants.colors.red};
        `}
      >
        <h3>{translate('Timed out')}</h3>
      </div>
      <p
        css={css`
          margin-top: 20px;
        `}
      >
        {translate(
          "This account hasn't been validated with Amex within 14 days of registering it with ${appName}.",
          {
            appName: <AppName />,
          },
        )}
      </p>
      <ol
        css={css`
          padding: 0;
          counter-reset: item;
        `}
      >
        <ListItem>
          {translate(
            'You will need to contact us via our ${resourceCenter} and request it be removed.',
            {
              resourceCenter: (
                <ResourceCenterLink size={HoverableLinkSizes.Large} underline />
              ),
            },
          )}
        </ListItem>
        <ListItem>
          {translate(
            'Once removed, we will notify you to register it again. Make sure to activate it within 14 days of registration.',
          )}
        </ListItem>
      </ol>
    </Box>
  )
}

export default AccountVerificationTimedOutBox
